module.exports = __webpack_public_path__ + "img/BW.0084d7bc.png";